export const ProductTestimonialsENUSTranslations = {
  productTestimonialsTitle: 'What our clients are saying',
  productTestimonialClientAlt: 'Client image',
};
